import { EventDispatcher } from "./EventDispatcher.js";

export class ActionYd extends EventDispatcher {
    constructor(args = {}) {
        super()

        if (args.onclick !== undefined) {
            this.onclick = args.onclick
        }
        if (args.ondblclick !== undefined) {
            this.ondblclick = args.ondblclick
        }
    }

    onclick(event) { }
    ondblclick(event) { }
}